import React from 'react';

const CloseWhiteIcon = ({ size = '40px' }) => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.75732 13.2426L13.2426 4.75736" stroke="#FFFFFF" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.2426 13.2426L4.75732 4.75735" stroke="#FFFFFF" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
};

export default CloseWhiteIcon;
